import { types } from "../actions";

const initialState = {
  floorImages: [],
  streamImages: [],
  unpairedImages: [],
  evidenceImages: {}, // key: mediaId || imageId → blobDataUrl
  evidenceVideoUrls: {}, // key: mediaId → s3Url string (S3 evidence only)
  hsEntityImages:[],
};

const imagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SAVE_FLOOR_IMAGE:
      const matchingFloorImagesItemIndex = state.floorImages.findIndex(
        (item) => item.id === action.payload.id
      );
      if (matchingFloorImagesItemIndex > -1) {
        const oldFloorImages = [...state.floorImages];
        oldFloorImages[matchingFloorImagesItemIndex] = action.payload;
        return {
          ...state,
          floorImages: [...oldFloorImages],
        };
      } else {
        return {
          ...state,
          floorImages: [...state.floorImages, action.payload],
        };
      }
    case types.DELETE_FLOOR_IMAGE:
      const oldFloorImages = [...state.floorImages];
      return {
        ...state,
        floorImages: [
          ...oldFloorImages.filter(
            (imageObj) => imageObj.id !== action.payload.id
          ),
        ],
      };
    case types.SAVE_UNPAIREDCAM_IMAGE:
      const matchingUnpairedItemIndex = state.unpairedImages.findIndex(
        (item) => item.id === action.payload.id
      );
      if (matchingUnpairedItemIndex > -1) {
        const oldUnpairedImages = [...state.unpairedImages];
        oldUnpairedImages[matchingUnpairedItemIndex] = action.payload;
        return {
          ...state,
          unpairedImages: [...oldUnpairedImages],
        };
      } else {
        return {
          ...state,
          unpairedImages: [...state.unpairedImages, action.payload],
        };
      }
    case types.SAVE_STREAM_IMAGE:
      const matchingStreamItemIndex = state.streamImages.findIndex(
        (item) => item.id === action.payload.id
      );
      if (matchingStreamItemIndex > -1) {
        const oldStreamImages = [...state.streamImages];
        oldStreamImages[matchingStreamItemIndex] = action.payload;
        return {
          ...state,
          streamImages: [...oldStreamImages],
        };
      } else {
        return {
          ...state,
          streamImages: [...state.streamImages, action.payload],
        };
      }
      case types.SAVE_HS_ENTITY_IMAGE:
      const matchingEntityItemIndex = state.hsEntityImages.findIndex(
        (item) => item.id === action.payload.id
      );
      if (matchingEntityItemIndex > -1) {
        const oldStreamImages = [...state.hsEntityImages];
        oldStreamImages[matchingEntityItemIndex] = action.payload;
        return {
          ...state,
          hsEntityImages: [...oldStreamImages],
        };
      } else {
        return {
          ...state,
          hsEntityImages: [...state.hsEntityImages, action.payload],
        };
      }
    case types.SAVE_EVIDENCE_IMAGE:
      return {
        ...state,
        evidenceImages: {
          ...state.evidenceImages,
          [action.payload.key]: action.payload.blobDataUrl,
        },
      };
    case types.SAVE_EVIDENCE_VIDEO_URL:
      return {
        ...state,
        evidenceVideoUrls: {
          ...state.evidenceVideoUrls,
          [action.payload.key]: action.payload.s3Url,
        },
      };
    default:
      return state;
  }
};
export default imagesReducer;
